import { render, staticRenderFns } from "./thirdIndex.vue?vue&type=template&id=075f075d&scoped=true&"
import script from "./thirdIndex.vue?vue&type=script&lang=js&"
export * from "./thirdIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f075d",
  null
  
)

export default component.exports